import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { pageRoutes } from "../routes/PageRoutes";
import {
  DeleteTask,
  fetchJobManegement,
} from "../redux/actions/maintainedBoatsActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import ReactPagination from "../layout/ReactPagination";
import PaginationDropdown from "../layout/PaginationDropdown";
import CustomDropdown from "../components/CustomDropdown";
import DeleteModal from "../components/modals/DeleteModal";

const statusOptions = [
  { label: "All Types", value: "" },
  { label: "Technician", value: "Technician" },
  { label: "Supplier", value: "Supplier" },
];

const statusOptions1 = [
  { label: "All Status", value: "" },
  { label: "Pending", value: "PENDING" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Completed", value: "COMPLETED" },
  { label: "Delayed", value: "DELAYED" },
];

const JobManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isToggle, setIsToggle] = useState(false);
  const { isLoading2, jobList } = useSelector(
    (state) => state?.maintainedReducer,
  );
  const [searchData, setSearchData] = useState("");
  const [status, setStatus] = useState("");
  const [status1, setStatus1] = useState(location?.state?.statusFilter || "");
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);
  const [selectedTaskId, setSelectedTaskId] = useState("");

  const today = new Date();
  const normalizedQuery = searchData.trim().toLowerCase();
  const filteredUsers = jobList?.filter((item) => {
    const searchFilter = normalizedQuery
      ? [item?.boatName, item?.jobLabel].some((field) =>
        field?.toLowerCase()?.includes(normalizedQuery),
      )
      : true;

    const statusMatch = status !== "" ? item?.assignedLabel == status : true;

    let statusMatch1 = true;
    if (status1 !== "") {
      statusMatch1 = item?.status?.label === status1;
    }

    return searchFilter && statusMatch && statusMatch1;
  });

  const displayUsers = filteredUsers?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage,
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  useEffect(() => {
    dispatch(fetchJobManegement());
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [searchData, status, status1]);

  useEffect(() => {
    const totalPages = Math.ceil((filteredUsers?.length || 0) / usersPerPage);

    if (totalPages > 0 && currentPage >= totalPages) {
      setCurrentPage(totalPages - 1);
    }

    if (totalPages === 0 && currentPage !== 0) {
      setCurrentPage(0);
    }
  }, [filteredUsers?.length, usersPerPage, currentPage]);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const handleDelete = () => {
    if (!selectedTaskId) {
      return;
    }

    const callback = (response) => {
      if (response?.success) {
        setSelectedTaskId("");
        dispatch(fetchJobManegement());
      }
    };

    dispatch(DeleteTask({ payload: selectedTaskId, callback }));
  };

  if (isLoading2) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="job-management" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              {/* content */}

              <div class="ct_flex_wrap_1199 d-flex align-items-center gap-3 justify-content-between">
                <div class="search-box ">
                  <div class="input-group position-relative">
                    <input
                      class="form-control ct_input ct_input_ps_40 ct_transparent_input"
                      placeholder="Search service name"
                      type="text"
                      value={searchData}
                      onChange={(e) => setSearchData(e.target.value)}
                    />
                    <i class="fas fa-search ct_show_search"></i>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-3 ct_flex_col_575 ct_w_100_1199  ">
                  <CustomDropdown
                    options={statusOptions}
                    selectedValue={status}
                    onChange={(value) => setStatus(value)}
                    placeholder="Select Status"
                  />
                  <CustomDropdown
                    options={statusOptions1}
                    selectedValue={status1}
                    onChange={(value) => setStatus1(value)}
                    placeholder="Select Status"
                  />
                  <a
                    // href="manage-service-preset.html"
                    href="javascript:void(0)"
                    onClick={() => {
                      navigate(pageRoutes?.maintained_boats);
                    }}
                    class="ct_orange_btn ct_grey_btn w-100 "
                  >
                    <svg
                      className="me-2 flex-shrink-0"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1233_17273)">
                        <path
                          d="M4.59739 18.0667C5.33073 18 6.06406 18.2667 6.66406 18.8C7.3974 19.5333 8.5974 19.5333 9.3974 18.8C10.0641 18.3333 10.7974 18.0667 11.5974 18.0667C12.3974 18 13.1974 18.2667 13.7974 18.8C14.1974 19.1333 14.6641 19.3333 15.1974 19.3333C15.7307 19.3333 16.1974 19.1333 16.5974 18.8C17.2641 18.2667 18.0641 18 18.8641 18C19.6641 18 20.4641 18.2667 21.1307 18.8C21.5307 19.1333 22.1307 19.3333 22.6641 19.3333V20.6667C21.7974 20.7333 20.9307 20.4667 20.2641 19.8667C19.8641 19.5333 19.2641 19.3333 18.7307 19.3333C18.2641 19.3333 17.7307 19.5333 17.3307 19.8667C16.1307 20.9333 14.2641 20.9333 12.9974 19.8667C12.5974 19.5333 12.1307 19.3333 11.5974 19.3333C11.1307 19.3333 10.6641 19.5333 10.2641 19.8667C8.9974 20.9333 7.1974 20.9333 5.93073 19.8667C5.59739 19.5333 5.06406 19.3333 4.59739 19.3333C4.13073 19.3333 3.66406 19.5333 3.33073 19.8667C2.73073 20.3333 2.06406 20.6 1.33073 20.6667V19.3333C1.99739 19.3333 2.13073 19.0667 2.46406 18.8C3.06406 18.3333 3.7974 18.0667 4.59739 18.0667Z"
                          fill="white"
                        />
                        <path
                          d="M19.999 15.334C19.999 14.934 19.6656 14.6673 19.2656 14.6673H2.66562L4.99896 16.734H4.86562C4.33229 16.734 3.79896 16.8673 3.39896 17.0673L1.73229 15.6007L1.59896 15.4673C1.13229 14.934 1.19896 14.0673 1.73229 13.6007C1.99895 13.4673 2.26562 13.334 2.59896 13.334H19.2656C20.399 13.334 21.2656 14.2007 21.2656 15.334V17.4673C20.9323 17.134 20.4656 16.934 19.999 16.734V15.334Z"
                          fill="white"
                        />
                        <path
                          d="M18.0679 12.6664H14.0012V7.46643C14.0012 7.06643 14.2012 6.66643 14.5345 6.39976C15.1345 5.9331 16.0012 6.06643 16.4012 6.66643L19.1345 10.5998C19.4012 10.9998 19.4012 11.5331 19.2012 11.9998C19.0012 12.3998 18.5345 12.6664 18.0679 12.6664ZM15.2679 7.46643L15.3345 11.3331H18.0679L15.2679 7.46643Z"
                          fill="white"
                        />
                        <path
                          d="M6.66927 11.9997C6.4026 11.5997 6.4026 11.0664 6.66927 10.6664L10.8693 3.73307C11.1359 3.33307 11.5359 3.06641 12.0026 3.06641C12.7359 3.06641 13.3359 3.66641 13.3359 4.39974V12.6664H7.8026C7.33594 12.6664 6.86927 12.3997 6.66927 11.9997ZM12.0693 4.39974L7.8026 11.3997H12.0693V4.39974Z"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1233_17273">
                          <rect
                            width="24"
                            height="24"
                            fill="white"
                            transform="matrix(-1 0 0 1 24 0)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Maintained Boats
                  </a>
                </div>
              </div>
              {displayUsers?.length != 0 ? (
                <div class="row g-3 ct_mt_30">
                  {/* â•â• CARD 1 â•â• */}
                  {displayUsers?.length != 0 &&
                    displayUsers?.map((item, i) => (
                      <div class="col-12 col-sm-6 col-lg-6 col-xl-4">
                        <div class="supplier-card h-100">
                          <div class="card-top d-flex gap-3 align-items-start justify-content-between mb-4">
                            <div class="d-flex gap-3 align-items-center">
                              <div class="name-block">
                                <h4 class="staff-name ct_text_para ct_fs_12 ct_fw_400 mb-0">
                                  {item?.jobLabel || "-"}
                                </h4>
                                <h4 class="ct_text_dark ct_fs_18 ct_fw_600 mb-2">
                                  Boat: {item?.boatName || "-"}
                                </h4>

                                <div class="mt-4 d-grid gap-3">
                                  <div class="d-flex gap-3">
                                    <div class="ct_custom_icon_box ct_border_radius_8 ct_bg_62748E21">
                                      <svg
                                        width="22"
                                        height="18"
                                        viewBox="0 0 22 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M0 18V15.2C0 14.65 0.141667 14.1333 0.425 13.65C0.708333 13.1667 1.1 12.8 1.6 12.55C2.45 12.1167 3.40833 11.75 4.475 11.45C5.54167 11.15 6.71667 11 8 11C9.28333 11 10.4583 11.15 11.525 11.45C12.5917 11.75 13.55 12.1167 14.4 12.55C14.9 12.8 15.2917 13.1667 15.575 13.65C15.8583 14.1333 16 14.65 16 15.2V18H0ZM2 16H14V15.2C14 15.0167 13.9542 14.85 13.8625 14.7C13.7708 14.55 13.65 14.4333 13.5 14.35C12.9 14.05 12.1292 13.75 11.1875 13.45C10.2458 13.15 9.18333 13 8 13C6.81667 13 5.75417 13.15 4.8125 13.45C3.87083 13.75 3.1 14.05 2.5 14.35C2.35 14.4333 2.22917 14.55 2.1375 14.7C2.04583 14.85 2 15.0167 2 15.2V16ZM8 10C6.9 10 5.95833 9.60833 5.175 8.825C4.39167 8.04167 4 7.1 4 6H3.75C3.6 6 3.47917 5.95417 3.3875 5.8625C3.29583 5.77083 3.25 5.65 3.25 5.5C3.25 5.35 3.29583 5.22917 3.3875 5.1375C3.47917 5.04583 3.6 5 3.75 5H4C4 4.25 4.18333 3.575 4.55 2.975C4.91667 2.375 5.4 1.9 6 1.55V2.5C6 2.65 6.04583 2.77083 6.1375 2.8625C6.22917 2.95417 6.35 3 6.5 3C6.65 3 6.77083 2.95417 6.8625 2.8625C6.95417 2.77083 7 2.65 7 2.5V1.15C7.15 1.1 7.30833 1.0625 7.475 1.0375C7.64167 1.0125 7.81667 1 8 1C8.18333 1 8.35833 1.0125 8.525 1.0375C8.69167 1.0625 8.85 1.1 9 1.15V2.5C9 2.65 9.04583 2.77083 9.1375 2.8625C9.22917 2.95417 9.35 3 9.5 3C9.65 3 9.77083 2.95417 9.8625 2.8625C9.95417 2.77083 10 2.65 10 2.5V1.55C10.6 1.9 11.0833 2.375 11.45 2.975C11.8167 3.575 12 4.25 12 5H12.25C12.4 5 12.5208 5.04583 12.6125 5.1375C12.7042 5.22917 12.75 5.35 12.75 5.5C12.75 5.65 12.7042 5.77083 12.6125 5.8625C12.5208 5.95417 12.4 6 12.25 6H12C12 7.1 11.6083 8.04167 10.825 8.825C10.0417 9.60833 9.1 10 8 10ZM8 8C8.55 8 9.02083 7.80417 9.4125 7.4125C9.80417 7.02083 10 6.55 10 6H6C6 6.55 6.19583 7.02083 6.5875 7.4125C6.97917 7.80417 7.45 8 8 8ZM15.5 12L15.35 11.25C15.25 11.2167 15.1542 11.1792 15.0625 11.1375C14.9708 11.0958 14.8833 11.0333 14.8 10.95L14.1 11.2L13.6 10.3L14.15 9.8C14.15 9.75 14.15 9.7 14.15 9.65C14.15 9.6 14.15 9.55 14.15 9.5C14.15 9.45 14.15 9.4 14.15 9.35C14.15 9.3 14.15 9.25 14.15 9.2L13.6 8.7L14.1 7.8L14.8 8.05C14.8667 7.98333 14.95 7.925 15.05 7.875C15.15 7.825 15.25 7.78333 15.35 7.75L15.5 7H16.5L16.65 7.75C16.75 7.78333 16.85 7.825 16.95 7.875C17.05 7.925 17.1333 7.98333 17.2 8.05L17.9 7.8L18.4 8.7L17.85 9.2C17.85 9.25 17.85 9.3 17.85 9.35C17.85 9.4 17.85 9.45 17.85 9.5C17.85 9.55 17.85 9.6 17.85 9.65C17.85 9.7 17.85 9.75 17.85 9.8L18.4 10.3L17.9 11.2L17.2 10.95C17.1167 11.0333 17.0292 11.0958 16.9375 11.1375C16.8458 11.1792 16.75 11.2167 16.65 11.25L16.5 12H15.5ZM16 10.25C16.2 10.25 16.375 10.175 16.525 10.025C16.675 9.875 16.75 9.7 16.75 9.5C16.75 9.3 16.675 9.125 16.525 8.975C16.375 8.825 16.2 8.75 16 8.75C15.8 8.75 15.625 8.825 15.475 8.975C15.325 9.125 15.25 9.3 15.25 9.5C15.25 9.7 15.325 9.875 15.475 10.025C15.625 10.175 15.8 10.25 16 10.25ZM17.8 7L17.6 5.95C17.45 5.9 17.3125 5.8375 17.1875 5.7625C17.0625 5.6875 16.95 5.6 16.85 5.5L15.8 5.85L15.1 4.65L15.95 3.9C15.9167 3.81667 15.9 3.75 15.9 3.7C15.9 3.65 15.9 3.58333 15.9 3.5C15.9 3.41667 15.9 3.35 15.9 3.3C15.9 3.25 15.9167 3.18333 15.95 3.1L15.1 2.35L15.8 1.15L16.85 1.5C16.95 1.4 17.0625 1.3125 17.1875 1.2375C17.3125 1.1625 17.45 1.1 17.6 1.05L17.8 0H19.2L19.4 1.05C19.55 1.1 19.6875 1.1625 19.8125 1.2375C19.9375 1.3125 20.05 1.4 20.15 1.5L21.2 1.15L21.9 2.35L21.05 3.1C21.0833 3.18333 21.1 3.25 21.1 3.3C21.1 3.35 21.1 3.41667 21.1 3.5C21.1 3.58333 21.1 3.65 21.1 3.7C21.1 3.75 21.0833 3.81667 21.05 3.9L21.9 4.65L21.2 5.85L20.15 5.5C20.05 5.6 19.9375 5.6875 19.8125 5.7625C19.6875 5.8375 19.55 5.9 19.4 5.95L19.2 7H17.8ZM18.5 4.75C18.85 4.75 19.1458 4.62917 19.3875 4.3875C19.6292 4.14583 19.75 3.85 19.75 3.5C19.75 3.15 19.6292 2.85417 19.3875 2.6125C19.1458 2.37083 18.85 2.25 18.5 2.25C18.15 2.25 17.8542 2.37083 17.6125 2.6125C17.3708 2.85417 17.25 3.15 17.25 3.5C17.25 3.85 17.3708 4.14583 17.6125 4.3875C17.8542 4.62917 18.15 4.75 18.5 4.75Z"
                                          fill="#62748E"
                                        />
                                      </svg>
                                    </div>
                                    <div>
                                      <p class="ct_fs_12 mb-0 ct_text_para">
                                        {item?.assignedLabel || "-"}
                                      </p>
                                      <h5 class="ct_fs_16 ct_text_dark">
                                        {item?.assignedName || "-"}
                                      </h5>
                                    </div>
                                  </div>
                                  <div class="d-flex gap-3">
                                    <div class="ct_custom_icon_box ct_border_radius_8 ct_bg_62748E21">
                                      <svg
                                        width="24"
                                        height="26"
                                        viewBox="0 0 24 26"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M3.86719 9.66602H19.3339"
                                          stroke="#62748E"
                                          stroke-width="2.14806"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M3.86719 16.1094H19.3339"
                                          stroke="#62748E"
                                          stroke-width="2.14806"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M9.6599 3.2207L7.72656 22.5532"
                                          stroke="#62748E"
                                          stroke-width="2.14806"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M15.4724 3.2207L13.5391 22.5532"
                                          stroke="#62748E"
                                          stroke-width="2.14806"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                    </div>
                                    <div>
                                      <p class="ct_fs_12 mb-0 ct_text_para">
                                        Rego
                                      </p>
                                      <h5 class="ct_fs_16 ct_text_dark">
                                        {item?.rego || "-"}
                                      </h5>
                                    </div>
                                  </div>

                                  <div class="d-flex gap-3">
                                    <div class="ct_custom_icon_box ct_border_radius_8 ct_bg_62748E21">
                                      <svg
                                        width="25"
                                        height="25"
                                        viewBox="0 0 25 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M16.7973 1.95312V3.05156C16.1565 3.16048 15.548 3.41081 15.016 3.78437L14.2098 3.02656L13.1355 4.175L13.9168 4.90703C13.5603 5.42837 13.3187 6.01957 13.2082 6.64141H12.1098V8.20391H13.2082C13.3223 8.85234 13.5785 9.44297 13.941 9.96172L13.1105 10.7664L14.2355 11.8914L15.0402 11.0602C15.559 11.4227 16.1496 11.6789 16.798 11.793V12.8906H18.3605V11.7922C18.9823 11.6819 19.5735 11.4406 20.0949 11.0844L20.8262 11.8656L21.9746 10.7906L21.2168 9.98594C21.584 9.4625 21.834 8.85703 21.9496 8.20312H23.0473V6.64062H21.9488C21.8366 6.00799 21.5864 5.40783 21.216 4.88281L21.9488 4.15L20.8496 3.05156L20.1176 3.78437C19.5926 3.41399 18.9924 3.16379 18.3598 3.05156V1.95312H16.7973ZM17.5785 4.54141C17.9575 4.53892 18.3332 4.61172 18.6839 4.75558C19.0345 4.89945 19.3531 5.11151 19.6211 5.37948C19.8892 5.64744 20.1013 5.96596 20.2453 6.31657C20.3893 6.66717 20.4622 7.04287 20.4598 7.42188C20.4598 9.02734 19.184 10.3031 17.5785 10.3031C15.973 10.3031 14.6973 9.02734 14.6973 7.42188C14.6973 5.81641 15.973 4.54062 17.5785 4.54062V4.54141ZM7.4457 9.15469L6.00664 9.74063L6.56758 11.1547C5.82093 11.6016 5.19283 12.2217 4.73633 12.9625L3.3457 12.4L2.75977 13.8414L4.15039 14.4023C4.04067 14.825 3.98347 15.2595 3.98008 15.6961C3.98008 16.1414 4.04648 16.5758 4.15039 16.9898L2.75977 17.5523L3.3457 18.9922L4.73633 18.4297C5.18877 19.1801 5.81733 19.809 6.56758 20.2617L6.00508 21.6523L7.44648 22.2383L8.00898 20.8477C8.4316 20.9574 8.86612 21.0146 9.30273 21.018C9.74805 21.018 10.184 20.9516 10.5965 20.8477L11.159 22.2383L12.5988 21.6523L12.0363 20.2617C12.7779 19.8062 13.3982 19.1779 13.8441 18.4305L15.2582 18.9914L15.8441 17.5516L14.4301 16.9891C14.5316 16.575 14.6004 16.1398 14.6004 15.6953C14.6004 15.25 14.5324 14.8141 14.4285 14.4008L15.8449 13.8398L15.259 12.3984L13.8449 12.9609C13.396 12.2221 12.776 11.602 12.0371 11.1531L12.5996 9.73906L11.1582 9.15312L10.598 10.5672C10.1749 10.4592 9.74025 10.4023 9.30352 10.3977C8.8582 10.3977 8.42383 10.4648 8.00977 10.568L7.44727 9.15391L7.4457 9.15469ZM9.30195 11.9609C11.3824 11.9609 13.0363 13.6172 13.0363 15.6969C13.0379 17.7773 11.3824 19.4562 9.30195 19.4562C8.80809 19.4569 8.31896 19.36 7.86257 19.1713C7.40619 18.9826 6.99151 18.7057 6.6423 18.3565C6.29308 18.0073 6.01619 17.5926 5.82749 17.1363C5.63878 16.6799 5.54196 16.1907 5.54258 15.6969C5.54258 13.6164 7.22227 11.9609 9.30195 11.9609Z"
                                          fill="#62748E"
                                        />
                                      </svg>
                                    </div>
                                    <div>
                                      <p class="ct_fs_12 mb-0 ct_text_para">
                                        {item?.services?.count || ""} Services
                                      </p>
                                      <h5 class="ct_fs_16 ct_text_dark">
                                        {item?.services?.previewText || "-"}
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <details class="dd-details">
                              <summary class="dots-btn">
                                <i class="fa-solid fa-ellipsis-vertical"></i>
                              </summary>
                              <div class="dock-dropdown">
                                <a
                                  class="dd-item "
                                  href="javascript:void(0)"
                                  onClick={() => {
                                    navigate(pageRoutes?.JobDetail, {
                                      state: { data: item },
                                    });
                                  }}
                                >
                                  <svg
                                    class="dd-icon"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    viewBox="0 0 24 24"
                                  >
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                    <circle cx="12" cy="12" r="3" />
                                  </svg>
                                  View Job
                                </a>

                                {/* <a
                                  class="dd-item"
                                  href="javascript:void(0)"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_edit_technician_modal_post"
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M14.2366 1.76435C13.9933 1.5208 13.7044 1.32759 13.3863 1.19577C13.0683 1.06394 12.7274 0.996094 12.3831 0.996094C12.0389 0.996094 11.698 1.06394 11.3799 1.19577C11.0619 1.32759 10.773 1.5208 10.5296 1.76435L2.65763 9.63535C2.2838 10.0099 2.01722 10.4778 1.88563 10.9904L1.01563 14.3764C0.994056 14.4606 0.994828 14.549 1.01787 14.6329C1.04091 14.7167 1.08543 14.7931 1.14703 14.8545C1.20862 14.9159 1.28517 14.9602 1.3691 14.983C1.45303 15.0057 1.54145 15.0062 1.62563 14.9844L5.01063 14.1154C5.52301 13.9841 5.99067 13.7174 6.36463 13.3434L14.2366 5.47135C14.4802 5.22803 14.6734 4.9391 14.8052 4.62106C14.937 4.30303 15.0049 3.96213 15.0049 3.61785C15.0049 3.27358 14.937 2.93268 14.8052 2.61465C14.6734 2.29661 14.4802 2.00768 14.2366 1.76435ZM11.2366 2.47135C11.5407 2.16728 11.9531 1.99646 12.3831 1.99646C12.8132 1.99646 13.2256 2.16728 13.5296 2.47135C13.8337 2.77543 14.0045 3.18783 14.0045 3.61785C14.0045 4.04788 13.8337 4.46028 13.5296 4.76435L12.7506 5.54335L10.4576 3.25035L11.2366 2.47135ZM9.75063 3.95735L12.0436 6.25035L5.65763 12.6364C5.41013 12.8837 5.10064 13.0598 4.76163 13.1464L2.19463 13.8064L2.85463 11.2394C2.94071 10.9002 3.11693 10.5906 3.36463 10.3434L9.75063 3.95735Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                  Edit Job
                                </a> */}

                                <a
                                  class="dd-item"
                                  href="#"
                                  data-bs-toggle="modal"
                                  data-bs-target="#ct_delete_jobmngmnt_modal_post"
                                  onClick={() =>
                                    setSelectedTaskId(item?.taskId)
                                  }
                                >
                                  <svg
                                    class="dd-icon"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    viewBox="0 0 24 24"
                                  >
                                    <polyline points="3 6 5 6 21 6" />
                                    <path d="M19 6l-1 14H6L5 6" />
                                    <path d="M10 11v6" />
                                    <path d="M14 11v6" />
                                    <path d="M9 6V4h6v2" />
                                  </svg>
                                  Delete Job
                                </a>
                              </div>
                            </details>
                          </div>

                          <div>
                            <div class="d-flex justify-content-between gap-3 align-items-center">
                              <h6 class="ct_fs_14 ct_fw_400 ct_text_para mb-0 text-uppercase">
                                Due date:
                              </h6>
                              <span class="ct_fs_14 ct_fw_500">
                                {item?.dueDate || "-"}
                              </span>
                            </div>

                            <div class="d-flex justify-content-between gap-3 align-items-center">
                              <h6 class="ct_fs_14 ct_fw_400 ct_text_para mb-0 text-uppercase">
                                STATUS:
                              </h6>
                              <div class="d-flex align-items-center gap-2">
                                <span
                                  class="active-dot"
                                  style={{
                                    backgroundColor: item?.status?.dotColor,
                                  }}
                                ></span>
                                <span
                                  class="ct_active_badge text-capitalize"
                                  style={{ color: item?.status?.textColor }}
                                >
                                  {item?.status?.label?.toLowerCase() || ""}
                                </span>

                                {/* status pending overdue */}
                                {/* <span class="inactive-dot"></span>
                        <span class="ct_inactive_badge">Overdue</span>

                        <span class="pending-dot"></span>
                        <span class="ct_pending_badge">Pending</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                  {/*Edit Job Management modal */}

                  <div
                    class="modal fade"
                    id="ct_edit_technician_modal_post"
                    tabindex="{-1}"
                    aria-labelledby="ct_edit_technician_postLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-lg modal-dialog-centered">
                      <div class="modal-content ct_border_radius_20">
                        <div class="modal-body">
                          <div class="ct_delete_post_modal p-4">
                            <figure>
                              <figcaption>
                                <div class="d-flex justify-content-between align-items-start">
                                  <div class="">
                                    <h4 class="ct_fs_24 ct_fw_600 ct_blue_text mb-2">
                                      Edit Technician/Supplier
                                    </h4>
                                    <p class="mb-0 ct_text_para ct_fs_16">
                                      Edit Technician/Supplier
                                    </p>
                                  </div>
                                  <div
                                    data-bs-dismiss="modal"
                                    class="ct_pointer"
                                  >
                                    <i class="fa-solid fa-xmark"></i>
                                  </div>
                                </div>
                              </figcaption>

                              <form class="mt-5">
                                <div class="row">
                                  <div class="col-lg-6">
                                    <div class="form-group mb-3">
                                      <label class="form-label">
                                        {" "}
                                        Assign To{" "}
                                      </label>
                                      <select
                                        class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                        id="boatId"
                                      >
                                        <option value="">Technician</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-lg-6">
                                    <div class="form-group mb-3">
                                      <label class="form-label">
                                        Select Technician
                                      </label>
                                      <select
                                        class="form-control ct_input ct_transparent_input ct_pointer_curser"
                                        id="boatId"
                                      >
                                        <option value="">Select</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-lg-6">
                                    <div class="form-group mb-3">
                                      <label class="form-label">
                                        {" "}
                                        Start Date{" "}
                                      </label>
                                      <input
                                        type="date"
                                        class="form-control ct_input ct_transparent_input"
                                      />
                                    </div>
                                  </div>

                                  <div class="col-lg-6">
                                    <div class="form-group">
                                      <label class="form-label">
                                        {" "}
                                        End Date{" "}
                                      </label>
                                      <input
                                        type="date"
                                        class="form-control ct_input ct_transparent_input"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </figure>
                            <div class="d-flex justify-content-end border-0 gap-2 ct_modal_footer ct_mt_30">
                              <a
                                data-bs-dismiss="modal"
                                class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn px-5 text-center ct_pointer"
                              >
                                Cancel
                              </a>
                              <a
                                data-bs-dismiss="modal"
                                class="ct_border_radius_5 ct_h_40 ct_orange_btn px-5 text-center ct_pointer"
                              >
                                Save Changes
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="text-center">
                  <p className="mb-0 mt-5 text-center fw-bold">
                    No record found
                  </p>
                </div>
              )}
            </div>

            <DeleteModal
              modalId="ct_delete_jobmngmnt_modal_post"
              heading="Delete Job?"
              value="Are you sure you want to delete this job? This action cannot be undone."
              confirmText="Yes, Delete"
              handleDelete={handleDelete}
            />

            <div className="mt-3">
              {filteredUsers?.length >= 5 && filteredUsers?.length > 0 && (
                <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-3">
                  <PaginationDropdown
                    onChange={(val) => {
                      setUserPerPages(val);
                      setCurrentPage(0);
                    }}
                  />
                  <ReactPagination
                    pageCount={Math.ceil(filteredUsers.length / usersPerPage)}
                    onPageChange={handlePageClick}
                    currentPage={currentPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobManagement;
